import type { FC } from 'react';
import { faClock, faMoneyBill } from '~/assets';
import { CreditLimit, SceneWrapper, SectionTitle } from '~/components';
import { currencyParser } from '~/modules';
import {
  BenefitCard,
  BenefitCardDescription,
  BenefitCardIcon,
  BenefitCardTitle,
  BenefitsSection,
  ButtonComponent,
} from './styles';

type CreditSimulationIntroProps = {
  onSubmit: () => void;
  availableLimit: number;
};

const CreditSimulationIntro: FC<CreditSimulationIntroProps> = ({
  onSubmit,
  availableLimit,
}) => {
  return (
    <SceneWrapper
      footer={
        <ButtonComponent onPress={onSubmit} id="button-start-simulation">
          SIMULAR AGORA
        </ButtonComponent>
      }
    >
      <SectionTitle>
        Inicie a contratação de seu empréstimo pessoal
      </SectionTitle>
      <CreditLimit
        title="Limite disponível pré-aprovado"
        value={currencyParser(availableLimit || '')}
        warningText="Valor total disponível sujeito a análise de crédito"
      />
      <SectionTitle>Conheça os benefícios</SectionTitle>
      <BenefitsSection>
        <BenefitCard>
          <BenefitCardIcon icon={faClock} />
          <BenefitCardTitle>Simples e rápido</BenefitCardTitle>
          <BenefitCardDescription>
            O dinheiro é liberado em sua conta em até 1 dia útil.
          </BenefitCardDescription>
        </BenefitCard>
        <BenefitCard>
          <BenefitCardIcon icon={faMoneyBill} />
          <BenefitCardTitle>Pagamento facilitado</BenefitCardTitle>
          <BenefitCardDescription>
            Realize o pagamento via débito automático em conta.
          </BenefitCardDescription>
        </BenefitCard>
      </BenefitsSection>
    </SceneWrapper>
  );
};

export default CreditSimulationIntro;
